export const recaptchaKey = '6LfUiboUAAAAABddUBOCmc6T_Oj8r26cJ2AzKWZW';
